import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
    components: { ValidationProvider },
})
export default class FormRadio extends Vue {
    localModel = null;

    @Prop()
    public model;

    @Prop({ type: Array, default: [] })
    public items: Array<Object>;

    @Prop({ type: String })
    public itemText: string;

    @Prop({ type: String })
    public itemValue: string;

    @Prop({ type: String })
    public rules: string;

    @Prop({ type: String })
    public name: string;

    @Prop({ type: String })
    public label: string;

    @Prop({ type: String, default: "2" })
    public sm: string;

    @Prop({ type: String, default: "2" })
    public md: string;

    @Prop({ type: Boolean })
    public required: Boolean;

    @Prop()
    value;

    @Prop()
    public change;

    @Watch("localModel")
    updateParentModel(value) {
        this.$emit("change", value);
    }

    @Watch("value")
    updateLocalModel(value) {
        this.localModel = value;
    }

    mounted() {
        this.localModel = this.value;
    }
}
